import React, {Fragment} from 'react'
import FormErrorList from './FormErrorList'

const AuthForm = ({formErrors = {}, formValues, isSignup, onChange}) => {
  return (
    <div>
      <div className="mb-m">
        <FormErrorList errors={formErrors.form}/>
      </div>
      {isSignup === true &&
        <Fragment>
          <span className="block n color-gray-d must">お名前</span>
          <div className="columns mb-m is-multiline is-mobile">
            <div className="column is-6">
              <input
                name="family_name"
                onChange={onChange}
                placeholder="山田"
                type="text"
                value={formValues.family_name}
              />
              <FormErrorList errors={formErrors.family_name}/>
            </div>
            <div className="column is-6">
              <input
                name="given_name"
                onChange={onChange}
                placeholder="太郎"
                type="text"
                value={formValues.given_name}
              />
              <FormErrorList errors={formErrors.given_name}/>
            </div>
          </div>
          <span className="block n color-gray-d must">電話番号</span>
          <div className="columns mb-m is-multiline is-mobile">
            <div className="column is-4">
              <input
                name="phone_number_0"
                onChange={onChange}
                placeholder="090"
                type="text"
                value={formValues.phone_number_0}
              />
              <FormErrorList errors={formErrors.phone_number}/>
            </div>
            <div className="column is-4">
              <input
                name="phone_number_1"
                onChange={onChange}
                placeholder="1234"
                type="text"
                value={formValues.phone_number_1}
              />
            </div>
            <div className="column is-4">
              <input
                name="phone_number_2"
                onChange={onChange}
                placeholder="5678"
                type="text"
                value={formValues.phone_number_2}
              />
            </div>
          </div>
        </Fragment>
      }
      <span className="block n color-gray-d must">メールアドレス</span>
      <div className="columns mb-m is-multiline is-mobile">
        <div className="column">
          <input
            name="email"
            onChange={onChange}
            placeholder="mail@solsell.jp"
            type="email"
            value={formValues.email}
          />
          <FormErrorList errors={formErrors.email}/>
        </div>
      </div>
      <span className="block n color-gray-d must">パスワード</span>
      <div className="columns mb-m is-multiline">
        <div className="column is-12">
          <input
            name="password"
            onChange={onChange}
            type="password"
            value={formValues.password}
          />
          <FormErrorList errors={formErrors.password}/>
        </div>
      </div>
      {isSignup === true &&
        <Fragment>
          <span className="block n color-gray-d must">パスワード設定<small>（再入力）</small></span>
          <div className="columns mb-m is-multiline">
            <div className="column is-12">
              <input
                name="password_1"
                onChange={onChange}
                type="password"
                value={formValues.password_1}
              />
              <FormErrorList errors={formErrors.password_1}/>
            </div>
          </div>
        </Fragment>
      }
      <div style={{textAlign: 'center'}}>
        <a href="/privacy/" className="n text-ss column icon icon-left icon-chevron-right icon-blue-l color-b">
          個人情報のお取り扱いについて
        </a>
      </div>
    </div>
  )
}

export default AuthForm
